const MESSAGES = Object.freeze({
  "Demo Mode": "Демонстрационный режим",
  "OK": "Хорошо",
  "Settings": "Настройки",
  "All changes reset every hour. Do not enter real data.": "Все изменения сбрасываются каждый час. Не вводите реальные данные.",
  "Loading...": "Загрузка…",
  "Loading invitation...": "Загружаем приглашение…",
  "Loading users...": "Загружаем сотрудников…",
  "Card not found.": "Визитка не найдена.",
  "Card Not Found": "Визитка не найдена",
  "The card you are looking for does not exist.": "Такой визитки не существует.",
  "Initial Setup": "Первоначальная настройка",
  "Configure your organisation and create the first admin user": "Настройте организацию и создайте первую учётную запись администратора",
  "Organisation Name": "Название организации",
  "Organization Name": "Название организации",
  "Admin Email": "Электронная почта администратора",
  "Admin Password": "Пароль администратора",
  "My Organization": "RuCortex",
  "My Organisation": "RuCortex",
  "Minimum 8 characters": "Не менее 8 символов",
  "Password must be at least 8 characters long": "Пароль должен содержать не менее 8 символов",
  "Password must be at least 8 characters": "Пароль должен содержать не менее 8 символов",
  "Login": "Войти",
  "Logout": "Выйти",
  "People": "Сотрудники",
  "(You)": "(Вы)",
  "Joined": "В системе с",
  "Manage your people": "Управляйте сотрудниками и их визитками",
  "Organisation": "Организация",
  "Org": "Организация",
  "Users": "Пользователи",
  "New Person": "Новая визитка",
  "Member": "Сотрудник",
  "Owner": "Владелец",
  "Role": "Роль",
  "Cancel": "Отмена",
  "Save": "Сохранить",
  "Saving...": "Сохраняем…",
  "Saved": "Сохранено",
  "Done": "Готово",
  "Close": "Закрыть",
  "Confirm": "Подтвердить",
  "Create": "Создать",
  "Remove": "Удалить",
  "Delete": "Удалить",
  "Retry": "Повторить",
  "View": "Открыть",
  "Edit": "Изменить",
  "Preview": "Предпросмотр",
  "Back to Dashboard": "К списку визиток",
  "Cannot modify yourself": "Нельзя изменить собственную учётную запись",
  "Short Code URL": "Короткая ссылка на визитку",
  "Short:": "Короткая ссылка:",
  "Org-scoped URL": "Ссылка организации",
  "Legacy URL": "Старая ссылка",
  "URL:": "Адрес:",
  "Create Card": "Создать визитку",
  "Create New Card": "Новая визитка",
  "Create your first card to get started.": "Создайте первую визитку, чтобы начать работу.",
  "You don't have a card yet": "У вас пока нет визитки",
  "What would you like to do?": "Что хотите сделать?",
  "No people yet. Click \"New Person\" to start.": "Пока нет визиток. Нажмите «Новая визитка», чтобы добавить первую.",
  "No users found": "Сотрудники не найдены",
  "You don't have permission to manage users.": "У вас нет прав для управления пользователями.",
  "No custom links yet.": "Пользовательских ссылок пока нет.",
  "Custom Links": "Пользовательские ссылки",
  "Add Link": "Добавить ссылку",
  "Add Color": "Добавить цвет",
  "Locked": "Недоступно",
  "Locked by Organisation": "Ограничено настройками организации",
  "Link": "Ссылка",
  "Link Title (e.g. Download CV)": "Название ссылки (например, «Скачать резюме»)",
  "Example Link": "Пример ссылки",
  "Example Button": "Пример кнопки",
  "Example Text": "Пример текста",
  "First Name": "Имя",
  "Last Name": "Фамилия",
  "Job Title": "Должность",
  "Email": "Электронная почта",
  "Password": "Пароль",
  "Phone": "Телефон",
  "Phone Number": "Номер телефона",
  "Website": "Сайт",
  "Location": "Местоположение",
  "Biography": "О себе",
  "Description": "Описание",
  "Title": "Должность",
  "Company": "Организация",
  "Add a phone number in Details to use this.": "Добавьте номер телефона в разделе «Контакты», чтобы использовать эту функцию.",
  "Advanced: Generated Styles": "Дополнительно: созданные стили",
  "By accepting this invitation, you agree to join the organization": "Принимая приглашение, вы соглашаетесь присоединиться к организации",
  "See my details": "Мои контакты",
  "Drop call me your number": "Оставьте свой номер коротким звонком",
  "WhatsApp me your number": "Отправить номер в WhatsApp",
  "Email me your details": "Отправить контакты по электронной почте",
  "Full details": "Полная визитка",
  "Link-only QR is available when you're online.": "QR-код со ссылкой доступен при подключении к интернету.",
  "Link-only QR is available when you&apos;re online.": "QR-код со ссылкой доступен при подключении к интернету.",
  "Switch to \"Full details\" to use your saved offline code.": "Чтобы использовать сохранённый офлайн-код, выберите «Полная визитка».",
  "This code includes your saved RuCortex Cards details and a link to your card when scanned with an online device.": "Этот QR-код содержит сохранённые контакты RuCortex Cards и ссылку на визитку для устройств с доступом в интернет.",
  "Install prompt failed. Please use your browser menu to install: Chrome/Edge (three dots menu > Install app), Firefox (menu > Install), or Safari (Share > Add to Home Screen).": "Не удалось открыть установку. Выберите в меню браузера «Установить приложение» или «Добавить на главный экран».",
  "Your details are only visible to you.": "Ваши контакты видны только вам.",
  "Organisation Settings": "Настройки организации",
  "Add website": "Добавить сайт",
  "Website name": "Название сайта",
  "Website URL": "Адрес сайта",
  "Drag to reorder": "Перетащите, чтобы изменить порядок",
  "Move link up": "Переместить ссылку выше",
  "Move link down": "Переместить ссылку ниже",
  "Remove link": "Удалить ссылку",
  "Upload custom icon": "Загрузить собственную иконку",
  "avatar": "Фото профиля",
  "banner": "Обложка",
  "Install app": "Установить приложение",
  "Share": "Поделиться",
  "Website name is required": "Укажите название сайта.",
  "Website URL is required": "Укажите адрес сайта.",
  "Invalid URL": "Некорректный адрес",
  "Invalid website URL": "Некорректный адрес сайта.",
  "Confirm Password": "Повторите пароль",
  "Enter password (min 8 characters)": "Введите пароль (не менее 8 символов)",
  "Confirm password": "Повторите пароль",
  "Organisation Settings": "Настройки организации",
  "Organisation Users": "Пользователи организации",
  "Organisation name is set by your organisation": "Название организации задаёт администратор",
  "This organisation name will be applied to all cards in your organisation. Users cannot change this.": "Это название будет указано на всех визитках организации. Сотрудники не могут его изменить.",
  "Default Organisation:": "Организация по умолчанию:",
  "An invitation email will be sent to this address": "На этот адрес будет отправлено приглашение.",
  "Invite User": "Пригласить сотрудника",
  "Send Invitation": "Отправить приглашение",
  "Sending...": "Отправляем…",
  "Sent!": "Отправлено!",
  "Invitations sent but not yet accepted": "Отправленные приглашения, которые ещё не приняты",
  "Pending Invitations": "Ожидают принятия",
  "No pending invitations": "Нет ожидающих приглашений",
  "Manage users and invitations for your organisation": "Управляйте сотрудниками и приглашениями в организацию",
  "Users currently in your organisation": "Сотрудники организации",
  "Invitation Invalid": "Приглашение недействительно",
  "Accept Invitation": "Принять приглашение",
  "Go to Login": "Перейти ко входу",
  "Creating Account...": "Создаём учётную запись…",
  "Welcome! Your account has been created.": "Добро пожаловать! Учётная запись создана.",
  "Pending": "Ожидает",
  "Sent": "Отправлено",
  "Failed": "Ошибка",
  "Expired": "Истекло",
  "Profile Picture": "Фото профиля",
  "Header Banner": "Обложка",
  "Upload": "Загрузить",
  "Uploading image...": "Загружаем изображение…",
  "Upload failed": "Не удалось загрузить файл.",
  "Your organisation has disabled custom image uploads. Contact your administrator to enable this feature.": "Администратор организации запретил загрузку собственных изображений. Обратитесь к нему, чтобы изменить настройку.",
  "Your organisation has disabled custom links. Contact your administrator to enable this feature.": "Администратор организации запретил добавление пользовательских ссылок. Обратитесь к администратору.",
  "Your organisation has disabled theme colour customisation. Your card will use the default theme colour.": "Настройка цвета ограничена организацией. Для визитки используется цвет по умолчанию.",
  "Your organisation has disabled send-your-details customisation. This is controlled by your organisation.": "Настройка кнопок обмена контактами ограничена организацией.",
  "Your organisation has disabled privacy settings customisation. Privacy settings are controlled by your organisation.": "Настройка параметров приватности ограничена организацией.",
  "User Customisation Controls": "Настройки доступности",
  "Control what users in your organisation can customise on their cards.": "Укажите, что сотрудники могут настраивать в своих визитках.",
  "Allow users to upload custom avatars and banners": "Разрешить загружать фото и обложки",
  "Allow users to add custom links": "Разрешить добавлять ссылки",
  "When enabled, users can add custom links to their cards. When disabled, the links section will be locked.": "Если включено, сотрудники смогут добавлять ссылки в визитки. Иначе этот раздел будет недоступен.",
  "Allow users to change privacy settings": "Разрешить менять настройки приватности",
  "Allow users to change send-your-details options": "Разрешить настраивать обмен контактами",
  "When enabled, users can enable/disable the send-your-details CTA and its individual channels. When disabled, these options are locked to their current values.": "Если включено, сотрудники смогут настраивать кнопку обмена контактами и способы отправки. Иначе останутся действующие параметры.",
  "Control whether users can add custom links to their cards.": "Разрешить сотрудникам добавлять пользовательские ссылки в визитки.",
  "Control whether users can change privacy settings on their cards.": "Разрешить сотрудникам менять настройки приватности визиток.",
  "Control whether users can choose theme colors for their cards.": "Разрешить сотрудникам выбирать цвета оформления визиток.",
  "Control whether users can upload custom avatars and banner images.": "Разрешить сотрудникам менять фото и обложку визитки.",
  "Choose the look for the app UI (backgrounds, chrome, buttons).": "Выберите оформление приложения: фон, элементы интерфейса и кнопки.",
  "App Themes": "Темы приложения",
  "Theme Customisation": "Настройка темы",
  "Profile Colors": "Цвета визитки",
  "Standard Colors": "Стандартные цвета",
  "Custom Colours": "Пользовательские цвета",
  "Base Color": "Основной цвет",
  "Secondary Color (optional)": "Дополнительный цвет (необязательно)",
  "Secondary: Auto (complementary)": "Дополнительный цвет: автоматически",
  "Leave blank to use auto (complementary) color": "Оставьте поле пустым для автоматического подбора дополнительного цвета",
  "Leave blank for auto (complementary)": "Оставьте пустым для автоматического подбора дополнительного цвета",
  "Gradient Background": "Градиентный фон",
  "Gradient Style:": "Стиль градиента:",
  "Button Style:": "Стиль кнопок:",
  "Link Style:": "Стиль ссылок:",
  "Text Style:": "Стиль текста:",
  "Color Effects:": "Эффекты цвета:",
  "Color Type": "Тип цвета",
  "Color Name": "Название цвета",
  "Text": "Текст",
  "Button": "Кнопка",
  "Auto": "Автоматически",
  "Not set": "Не задано",
  "Manage the color palette available for user cards.": "Управляйте палитрой цветов для визиток сотрудников.",
  "Original RuCortex Cards theme with colors and textures.": "Исходная тема RuCortex Cards с цветами и текстурами.",
  "Image Customisation": "Настройка изображений",
  "Links Customisation": "Настройка ссылок",
  "Privacy Settings": "Настройки приватности",
  "Require Interaction": "Показывать контакты по запросу",
  "Requires users to click a button to reveal email and phone. Prevents basic bots from seeing contact info in the initial page load.": "Посетителю нужно нажать кнопку, чтобы увидеть электронную почту и телефон. Это усложняет сбор контактов простыми ботами.",
  "Client-Side Obfuscation": "Скрывать контакты в исходном коде",
  "Encodes email and phone in the HTML to make scraping harder. Note: Determined scrapers can still decode this.": "Электронная почта и телефон кодируются в HTML, чтобы затруднить автоматический сбор. Защита не остановит целенаправленный разбор страницы.",
  "Block Search Engines": "Запретить индексацию",
  "Adds meta robots tag to prevent search engines from indexing this card.": "Добавляет директиву, запрещающую поисковым системам индексировать визитку.",
  "Send Your Details": "Поделиться контактами",
  "Send your details": "Поделиться контактами",
  "Shows a button on your public card that lets visitors send you their own contact details.": "Показывает на визитке кнопку, с помощью которой посетитель может отправить вам свои контакты.",
  "WhatsApp me your number": "Отправить номер в WhatsApp",
  "Lets visitors open WhatsApp with a pre-filled message to your number. Requires a WhatsApp-capable phone number.": "Открывает WhatsApp с подготовленным сообщением на ваш номер. Требуется номер, зарегистрированный в WhatsApp.",
  "Email me your details": "Отправить контакты по электронной почте",
  "Lets visitors open their email client with a pre-filled message to your email address.": "Открывает почтовое приложение с подготовленным письмом на ваш адрес.",
  "Drop call": "Звонок-сброс",
  "Drop call me your number": "Оставьте свой номер коротким звонком",
  "Lets visitors call your number so you have a missed-call record of their number.": "Посетитель может сделать короткий звонок, чтобы его номер сохранился в истории вызовов.",
  "See my details": "Мои контакты",
  "Call": "Позвонить",
  "Full details": "Полная визитка",
  "Link only": "Только ссылка",
  "Link-only QR is available when you're online.": "QR-код со ссылкой доступен при подключении к интернету.",
  "Offline QR ready": "Офлайн QR-код готов",
  "Only shared with me, never sold.": "Контакты видны только мне и не продаются.",
  "Save Contact": "Сохранить контакт",
  "QR code": "QR-код",
  "Show QR code": "Показать QR-код",
  "Saved details": "Сохранённые контакты",
  "Offline mode": "Автономный режим",
  "Loading your QR code...": "Загружаем QR-код…",
  "Connect once to generate and save your QR code for offline use.": "Подключитесь к интернету один раз, чтобы создать QR-код и сохранить его для автономного доступа.",
  "Using last saved QR details (offline). The code includes your contact info and a link to your RuCortex Cards card.": "Используется сохранённая версия QR-кода. В неё входят контакты и ссылка на вашу визитку RuCortex Cards.",
  "Switch to \"Full details\" to use your saved offline code.": "Чтобы использовать сохранённый офлайн-код, выберите «Полная визитка».",
  "Install app for offline access": "Установить приложение для работы без интернета",
  "Install RuCortex Cards": "Установить RuCortex Cards",
  "Install Failed": "Не удалось установить",
  "Already Installed": "Уже установлено",
  "This app is already installed on your device.": "Приложение уже установлено на устройстве.",
  "To install this app:": "Чтобы установить приложение:",
  "Chrome/Edge: Click the three dots menu (⋮) in the address bar, then select \"Install app\" or \"Add to Home Screen\".": "Chrome или Edge: откройте меню с тремя точками в адресной строке и выберите «Установить приложение» или «Добавить на главный экран».",
  "Firefox: Click the menu button, then select \"Install\" or \"Add to Home Screen\".": "Firefox: откройте меню браузера и выберите «Установить» или «Добавить на главный экран».",
  "Safari (iOS): Tap the Share button, then \"Add to Home Screen\".": "Safari (iOS): нажмите «Поделиться», затем выберите «На экран Домой».",
  "Open your browser menu and look for \"Install app\" or \"Add to Home Screen\" option.": "Откройте меню браузера и выберите «Установить приложение» или «Добавить на главный экран».",
  "Note: The install button may not be available if the app doesn't meet PWA requirements (service worker, valid manifest, etc.).": "Кнопка установки доступна, если приложение соответствует требованиям PWA, включая service worker и корректный manifest.",
  "Create New User": "Добавить сотрудника",
  "Create User": "Создать учётную запись",
  "User Management": "Управление сотрудниками",
  "Change Role": "Изменить роль",
  "Access Denied": "Доступ запрещён",
  "Error Loading Card": "Не удалось загрузить визитку",
  "Invalid User URL": "Некорректная ссылка",
  "User URL": "Короткая ссылка",
  "Enter a user URL for the new card (e.g., 'sarah'):": "Укажите адрес визитки, например: ivan-petrov",
  "Please enter a valid user URL (e.g., \"sarah\")": "Укажите корректный адрес визитки, например: ivan-petrov",
  "User URL must be at least 1 character long": "Адрес визитки не может быть пустым",
  "Email and password are required": "Укажите адрес электронной почты и пароль.",
  "Email is required": "Укажите адрес электронной почты.",
  "Password is required": "Укажите пароль.",
  "Passwords do not match": "Пароли не совпадают.",
  "Invalid email or password": "Неверная электронная почта или пароль.",
  "Login failed": "Не удалось войти. Проверьте данные и повторите попытку.",
  "Setup failed": "Не удалось завершить настройку",
  "Setup failed. Please try again.": "Не удалось завершить настройку. Попробуйте ещё раз.",
  "Connection failed": "Не удалось подключиться к серверу.",
  "Failed to load card": "Не удалось загрузить визитку.",
  "Save failed": "Не удалось сохранить изменения.",
  "Save failed:": "Не удалось сохранить изменения:",
  "Failed to save settings": "Не удалось сохранить настройки.",
  "Error saving settings": "Ошибка при сохранении настроек.",
  "You must have at least one color": "В палитре должен остаться хотя бы один цвет.",
  "Failed to load users": "Не удалось загрузить сотрудников.",
  "Error loading users": "Ошибка при загрузке сотрудников.",
  "Error creating user": "Ошибка при создании учётной записи.",
  "Error creating user. Please try again.": "Не удалось создать учётную запись. Попробуйте ещё раз.",
  "User role updated successfully": "Роль сотрудника обновлена.",
  "Error updating role": "Не удалось изменить роль сотрудника.",
  "User deleted successfully": "Сотрудник удалён.",
  "Error deleting user": "Не удалось удалить сотрудника.",
  "Failed to delete user": "Не удалось удалить сотрудника.",
  "User with this email already exists": "Сотрудник с таким адресом электронной почты уже существует.",
  "An active invitation already exists for this email. Please wait for the user to accept the invitation or delete it first.": "Для этого адреса уже есть действующее приглашение. Дождитесь его принятия или удалите приглашение.",
  "Invitation created but email failed to send. You can retry from the invitations list below.": "Приглашение создано, но письмо не отправлено. Попробуйте отправить его повторно из списка ниже.",
  "Invitation created but email failed to send. You can retry from the admin panel.": "Приглашение создано, но письмо не отправлено. Повторите отправку из панели управления.",
  "Invitation email sent successfully": "Приглашение отправлено.",
  "Failed to send invitation email": "Не удалось отправить приглашение.",
  "Failed to send invitation": "Не удалось отправить приглашение.",
  "Error sending invitation": "Ошибка при отправке приглашения.",
  "Error retrying invitation": "Не удалось повторно отправить приглашение.",
  "Invitation deleted": "Приглашение удалено.",
  "Error deleting invitation": "Не удалось удалить приглашение.",
  "Are you sure you want to delete this invitation?": "Удалить это приглашение?",
  "Delete Invitation": "Удалить приглашение",
  "Delete invitation": "Удалить приглашение",
  "Retry sending email": "Повторить отправку письма",
  "Failed to accept invitation": "Не удалось принять приглашение.",
  "Error accepting invitation": "Ошибка при принятии приглашения.",
  "Invitation not found or has expired": "Приглашение не найдено или срок его действия истёк.",
  "This invitation link is not valid or has expired.": "Ссылка приглашения недействительна или срок её действия истёк.",
  "Error loading invitation": "Не удалось загрузить приглашение.",
  "Delete User": "Удалить сотрудника",
  "Card deleted successfully": "Визитка удалена.",
  "Failed to delete card": "Не удалось удалить визитку.",
  "Email already in use": "Адрес уже используется",
  "Save anyway": "Всё равно сохранить",
  "Invalid URL": "Некорректный адрес",
  "Please enter a valid URL": "Укажите корректный адрес.",
  "Add website": "Добавить сайт",
  "Add Website": "Добавить сайт",
  "Websites": "Веб-сайты",
  "Website name": "Название сайта",
  "Website URL": "Адрес сайта",
  "You can add no more than 20 websites": "Можно добавить не более 20 сайтов.",
  "Each website needs a name and URL": "Для каждого сайта укажите название и адрес.",
  "Website name is too long": "Название сайта слишком длинное.",
  "Website URL must use HTTP or HTTPS": "Адрес сайта должен начинаться с http:// или https://.",
  "Invalid website URL": "Некорректный адрес сайта.",
  "Phone number must be a valid Russian number": "Укажите корректный российский номер телефона.",
  "Invalid Russian phone number": "Укажите корректный российский номер телефона.",
  "First name too long": "Имя слишком длинное.",
  "Last name too long": "Фамилия слишком длинная.",
  "Title too long": "Должность слишком длинная.",
  "Company name too long": "Название организации слишком длинное.",
  "Bio too long": "Описание слишком длинное.",
  "Location too long": "Местоположение слишком длинное.",
  "Invalid email format": "Некорректный адрес электронной почты.",
  "Phone too long": "Номер телефона слишком длинный.",
  "Invalid LinkedIn URL": "Некорректная ссылка LinkedIn.",
  "Invalid Twitter URL": "Некорректная ссылка Twitter.",
  "Invalid Instagram URL": "Некорректная ссылка Instagram.",
  "Invalid GitHub URL": "Некорректная ссылка GitHub.",
  "VK URL must use HTTPS and an approved VK host": "Для ссылки ВКонтакте используйте HTTPS и официальный домен vk.com.",
  "MAX URL must use HTTPS and an approved MAX host": "Для ссылки MAX используйте HTTPS и официальный домен max.ru.",
  "Links must be an array": "Список ссылок имеет неверный формат.",
  "Link title too long": "Название ссылки слишком длинное.",
  "Invalid link URL": "Некорректный адрес ссылки.",
  "Avatar URL too long": "Адрес изображения профиля слишком длинный.",
  "Banner URL too long": "Адрес обложки слишком длинный.",
  "Not found": "Страница не найдена.",
  "Unauthorized": "Требуется войти в систему.",
  "Forbidden: Insufficient permissions": "Недостаточно прав для выполнения этого действия.",
  "User not found": "Пользователь не найден.",
  "User not found in your organisation": "Сотрудник не найден в вашей организации.",
  "Cannot create card for user outside your organization": "Нельзя создать визитку для сотрудника другой организации.",
  "Cannot change your own role": "Нельзя изменить собственную роль.",
  "Cannot delete yourself": "Нельзя удалить собственную учётную запись.",
  "Cannot delete last owner from organization": "Нельзя удалить последнего владельца организации.",
  "Cannot remove last owner from organization": "Нельзя удалить последнего владельца организации.",
  "Role must be either \"owner\" or \"member\"": "Допустимые роли: «владелец» и «сотрудник».",
  "Role must be owner or member": "Допустимые роли: «владелец» и «сотрудник».",
  "Organisation name is required and must be less than 200 characters": "Укажите название организации длиной не более 199 символов.",
  "Organisation name too long": "Название организации слишком длинное.",
  "Valid email required": "Укажите корректный адрес электронной почты.",
  "Setup already completed": "Первоначальная настройка уже выполнена.",
  "Invalid file type": "Недопустимый тип файла.",
  "Invalid file extension": "Недопустимое расширение файла.",
  "File path is required": "Не указан путь к файлу.",
  "No file uploaded": "Файл не загружен.",
  "Invalid file type. Only images are allowed.": "Допускаются только файлы изображений.",
  "Too many login attempts, please try again later.": "Слишком много попыток входа. Повторите попытку позже.",
  "Too many upload attempts, please try again later.": "Слишком много попыток загрузки. Повторите попытку позже.",
  "Too many requests from this IP, please try again later.": "Слишком много запросов. Повторите попытку позже.",
  "Invalid user ID": "Некорректный идентификатор пользователя.",
  "Invalid invitation ID": "Некорректный идентификатор приглашения.",
  "Invalid invitation token": "Ссылка приглашения недействительна.",
  "Invitation not found": "Приглашение не найдено.",
  "Invitation has already been accepted": "Приглашение уже принято.",
  "Invitation has expired": "Срок действия приглашения истёк.",
  "Invitation has expired. Please delete and create a new one.": "Срок действия приглашения истёк. Удалите его и создайте новое.",
  "Email failed to send. Please check SMTP configuration.": "Не удалось отправить письмо. Обратитесь к администратору.",
  "Invalid or expired reset token": "Ссылка для смены пароля недействительна или срок её действия истёк.",
  "This reset token has already been used": "Эта ссылка для смены пароля уже использована.",
  "Reset token has expired": "Срок действия ссылки для смены пароля истёк.",
  "Current password is incorrect": "Текущий пароль указан неверно.",
  "Password has been changed successfully": "Пароль изменён.",
  "Password has been reset successfully": "Пароль изменён.",
  "Email is already verified": "Адрес электронной почты уже подтверждён.",
  "Verification email already sent. Please check your email or wait before requesting another.": "Письмо для подтверждения уже отправлено. Проверьте почту или повторите запрос позже.",
  "Failed to send verification email": "Не удалось отправить письмо для подтверждения.",
  "Verification email sent": "Письмо для подтверждения отправлено.",
  "Invalid verification token": "Ссылка подтверждения недействительна.",
  "Invalid or expired verification token": "Ссылка подтверждения недействительна или срок её действия истёк.",
  "Email has already been verified": "Адрес электронной почты уже подтверждён.",
  "Verification token has expired": "Срок действия ссылки подтверждения истёк.",
  "Email verified successfully": "Адрес электронной почты подтверждён.",
  "If an account exists with this email, a password reset link has been sent": "Если учётная запись с таким адресом существует, на него отправлена ссылка для смены пароля.",
  "Invalid identifier": "Некорректный идентификатор.",
  "Identifier must contain only letters, numbers, and hyphens": "Идентификатор может содержать только латинские буквы, цифры и дефисы.",
  "Identifier must be between 1 and 50 characters": "Длина идентификатора должна быть от 1 до 50 символов.",
  "Slug must be between 1 and 50 characters": "Адрес визитки должен содержать от 1 до 50 символов.",
  "Invalid data": "Переданы некорректные данные.",
  "Invalid card data": "Данные визитки имеют неверный формат.",
  "Invalid org slug": "Некорректный адрес организации.",
  "Invalid card slug": "Некорректный адрес визитки.",
  "Website URL must be a valid HTTP or HTTPS URL": "Укажите корректный URL с протоколом HTTP или HTTPS.",
  "Card not found": "Визитка не найдена.",
  "Control whether users can change the send-your-details options on their cards (the WhatsApp/email/call CTA shown to visitors).": "Разрешить сотрудникам настраивать способы, которыми посетители могут запросить их контакты: WhatsApp, электронную почту или звонок.",
  "Failed to update role": "Не удалось изменить роль сотрудника.",
  "Delete Card": "Удалить визитку",
  "Invalid input": "Переданы некорректные данные.",
  "Internal server error": "Внутренняя ошибка сервера.",
  "Please enter a valid email address": "Укажите корректный адрес электронной почты.",
  "File extension does not match file type": "Расширение файла не соответствует его типу.",
  "Too many short code lookup attempts": "Слишком много попыток поиска визитки. Повторите попытку позже.",
  "Short code must contain only letters and numbers": "Короткий код может содержать только латинские буквы и цифры.",
  "Failed to generate preview": "Не удалось создать предпросмотр визитки.",
  "Target user not found": "Сотрудник не найден.",
  "Active invitation already exists for this email": "Для этого адреса уже есть действующее приглашение.",
  "Cannot delete accepted invitation": "Нельзя удалить уже принятое приглашение.",
  "Link icon URL too long": "Ссылка на иконку слишком длинная.",
  "requireInteraction must be a boolean": "Параметр показа контактов должен иметь логическое значение.",
  "clientSideObfuscation must be a boolean": "Параметр скрытия контактов должен иметь логическое значение.",
  "blockRobots must be a boolean": "Параметр индексации должен иметь логическое значение.",
  "sendDetails.enabled must be a boolean": "Параметр обмена контактами должен иметь логическое значение.",
  "sendDetails.whatsapp must be a boolean": "Параметр WhatsApp должен иметь логическое значение.",
  "sendDetails.email must be a boolean": "Параметр электронной почты должен иметь логическое значение.",
  "sendDetails.call must be a boolean": "Параметр звонка должен иметь логическое значение.",
  "Slug must contain only lowercase letters, numbers, and hyphens": "Адрес визитки может содержать только латинские буквы, цифры и дефисы.",
  "An error occurred.": "Произошла ошибка. Повторите попытку.",
  "WhatsApp": "WhatsApp",

});

function translateMessage(value) {
  if (typeof value !== "string") return value;
  return Object.prototype.hasOwnProperty.call(MESSAGES, value.trim()) ? MESSAGES[value.trim()] : value;
}
function translateRole(value) {
  return value === "owner" ? "Владелец" : value === "member" ? "Сотрудник" : value;
}
function translateInvitationStatus(value) {
  return ({ sent: "Отправлено", failed: "Ошибка", pending: "Ожидает", expired: "Истекло", accepted: "Принято" })[value] || value;
}
module.exports = { translateInvitationStatus, translateMessage, translateRole, MESSAGES };
